// extracted by mini-css-extract-plugin
export default {"panel":"SuggestedUses_panel__pH+Zm","heading":"SuggestedUses_heading__6p7sI","grid":"SuggestedUses_grid__2DICz","icon":"SuggestedUses_icon__iH4ES"};